import React, {Component} from 'react';
import {  Link } from 'react-router-dom';
import axios from 'axios';
import Device from './models/Device';
import {v4 as uuidv4} from 'uuid';
// const querystring = require('querystring');
export default class CreateDevice extends Component {

	constructor(props)
	{
		console.log(props);
		super(props);
		let parms = "";
		//JSON.stringify(querystring.parse(this.props.location.search)).replace('?', '');
//         console.log("parms => " + parms);
		this.state={
			device : Device,
			identityPrincipal : ""
		}
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleOnLoad = this.handleOnLoad.bind(this);
		
		
	}
	handleChange(event) {
		console.log(event);
		var target = event.target;
		console.log(target.id + ":" + target.value);
		this.setState({device : {...this.state.device, [target.id] : target.value} });
	   
		console.log(this.state);
	  }
	handleSubmit(event) {

		event.preventDefault();
		console.log('handling submit');  
	  	var url = `${global.config.dataServicesUrl}/gazelle/Devices`;

		let idp = this.state.identityPrincipal;
		console.log('identity ' + idp + ":" + this.state.identityPrincipal);
		Device.id = uuidv4();
		Device.identityPrincipal = idp;
		Device.createUser = Device.lastUpdateUser = idp;
		Device.createDate = Device.lastUpdateDate = new Date();
		Device.name = this.state.device.name;
		Device.description = this.state.device.description;
		Device.notes = this.state.device.notes;
		
		console.log('b4 setState -> ' + JSON.stringify(Device));
		this.state.device = Device;

			console.log('saving state.device => ' + JSON.stringify(this.state.device));
			
			axios.post(url, this.state.device).then(response2 => {
				console.log("response.data");
				console.log(response2.status +":"+response2.data);
				if (response2.status === 200 )
				{
					this.message = "Success";

				}
				else
				{
					 this.message = "Failed";
				}        
				console.log(this.message);
		  	}).catch(err => {
				console.log("error - " + err);
		  	});

		console.log("message info - " + this.message); 
		window.location.href = '/vlm-homepage';
	 };
	 handleClear(){
		 this.setState({device : Device})
	 }
	 componentDidMount() 
	 {
	 	this.handleClear();
	 	
	 	var queryUrl = `${global.config.securityServicesUrl}/user-profile-service/email/${this.props.userId}`;
 		console.log('up url = ' + queryUrl);
		axios.get(queryUrl).then(response => {
// 				const currentUserProfileData = response.data; 
			console.log('setting idp - ' + response.data);
				this.setState({identityPrincipal : response.data});	
			console.log('set idp - ' + JSON.stringify(this.state));
			}).catch(function (error){
				console.log(error);
		});	

	 }

	handleOnLoad = () => {
//		this.handleClear();
		
// 		var queryUrl = `${global.config.securityServicesUrl}/user-profile-service/userprofile/${this.props.userId}`;
// 		console.log(queryUrl);
// 		axios.get(queryUrl)
// 		 	.then(response => {
// 			const currentUserProfileData = response.data; 
// 			console.log('updata -> ' + JSON.stringify(currentUserProfileData));
// 			this.setState({currentUserProfile : currentUserProfileData});	
// 			});
	}
	
	render(){
    return (
        	<div class="m-content">				
			<div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
       				<div class="m-grid__item m-grid__item--fluid m-wrapper">
					<div class="m-subheader ">					
						<div class="d-flex align-items-center">
							<div class="mr-auto">
								<h3 class="m-subheader__title m-subheader__title--separator">Gazelle VLM</h3>
								<ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
									<li class="m-nav__item m-nav__item--home">
										<Link to="/" class="m-nav__link m-nav__link--icon">
											<i class="m-nav__link-icon la la-home"></i>
										</Link>
									</li>
									<li class="m-nav__separator">-</li>
									<li class="m-nav__item">
										<Link to="/" class="m-nav__link">
											<span class="m-nav__link-text">Home</span>
										</Link>
									</li>
								</ul>
							</div>
							<div>
								<span class="m-subheader__daterange" id="m_dashboard_daterangepicker">
									<span class="m-subheader__daterange-label">
										<span class="m-subheader__daterange-title"></span>
										<span class="m-subheader__daterange-date m--font-brand"></span>
									</span>
									<a href="#" class="btn btn-sm btn-brand m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill">
										<i class="la la-angle-down"></i>
									</a>
								</span>
							</div>
						</div>
						<br />

					<div className="content-wrapper">
		
		<form>
		<div class="container-fluid">
		<h4>Create Device</h4>
		<hr />
		

		<div class="form-group row" >
		<label class="ContentTitle col-sm-2" >Name</label>
		<input id="name" class="form-control input-medium col-sm-8" value={this.state.device.name} onChange ={this.handleChange}/>
		</div>
			<div class="form-group row" >
		<label class="ContentTitle col-sm-2" >Description</label>
		<input id="description" class="form-control input-medium col-sm-8" value={this.state.device.description} onChange ={this.handleChange} /> 
		</div>

		<div class="form-group row" >
			<label class="ContentTitle col-sm-2" >Notes</label>
			<textarea id="notes" class="form-control input-medium col-sm-8" value={this.state.device.notes} onChange ={this.handleChange}>				
			</textarea>
		</div>
		<div class="form-group row" >
		<label class="ContentTitle col-sm-2">Serial Number</label>
		<input id="serialNumber" class="form-control input-medium col-sm-8" value={this.state.device.serialNumber} onChange ={this.handleChange} /> 
		</div>
		<div class="form-group row" >
		<label class="ContentTitle col-sm-2">Manufacturer</label>
		<input id="manufacturer" class="form-control input-medium col-sm-8" value={this.state.device.manufacturer} onChange ={this.handleChange} /> 
		</div>
		<div class="form-group row" >
		<label class="ContentTitle col-sm-2">Model</label>
		<input id="model" class="form-control input-medium col-sm-8" value={this.state.device.model} onChange ={this.handleChange} /> 
		</div>
		<div class="form-group row" >
		<label class="ContentTitle col-sm-2">Year</label>
		<input id="year" class="form-control input-medium col-sm-8" value={this.state.device.year} onChange ={this.handleChange} /> 
		</div>
		<div class="form-group row" >
		<label class="ContentTitle col-sm-2">Color</label>
		<input id="color" class="form-control input-medium col-sm-8" value={this.state.device.color} onChange ={this.handleChange} /> 
		</div>
		<div class="form-group row" >
		<label class="ContentTitle col-sm-2">Nickname</label>
		<input id="nickname" class="form-control input-medium col-sm-8" value={this.state.device.nickname} onChange ={this.handleChange} /> 
		</div>

		<hr />					
					<button class="btn btn-primary" value="Clear" onClick ={this.handleClear}>Clear</button> &nbsp;
					<button class="btn btn-success" value="Create" onClick ={this.handleSubmit}>Save</button>&nbsp;
		</div>		
		</form>
						</div>		

	            </div>	
            </div>
            
			</div>
			</div>
	);
}
}